module.exports = __webpack_public_path__ + "img/sky.b767bb34.jpg";